import { _ } from "libs";

import React from "react";
import { Profile, ReservationContext } from "../../../types";
import PlayerItemSmallColumn from "../../items/player/smallColumn";
import { formatName } from "../../../libs/formatName";
import { find, propEq } from "ramda";
import classNames from "classnames";

type Props = {
	me: Profile;
	onlyMe: boolean;
	onAddClick: any;
	partners: Array<any>;
	onRemoveClick: any;
	rules: ReservationContext["rules"];
	duration: number;
};

const Players = ({
	onlyMe = false,
	me,
	onAddClick,
	partners = [] as Profile[],
	onRemoveClick,
	rules,
	duration,
}: Props) => {
	let rule = find(propEq("duration", duration))(rules);

	if (!rule) {
		rule = {
			minPartners: 0,
			maxPartners: 3,
		};
	}

	const { minPartners, maxPartners } = rule;
	const otherPlayers = partners.concat([{}, {}, {}]).slice(0, maxPartners) as Profile[];

	return (
		<div className="cell playerSelector fourPlayerColumnsWrapper">
			<PlayerItemSmallColumn key={me.userId} name={_("me")} photoUrl={me.photoUrl} />
			{!onlyMe
				? otherPlayers.map((user, index) => {
						let required = index < minPartners;
						if (user.hasOwnProperty("type")) {
							return (
								<PlayerItemSmallColumn
									key={index}
									index={index}
									name={user.fullName ? user.fullName : formatName(user.firstName, user.lastName)}
									photoUrl={user.photoUrl}
									guest={user.type === "guest"}
									showRemoveIcon={true}
									onRemoveClick={onRemoveClick}
								/>
							);
						}
						return (
							<div className={`item player small column placeholder ${required ? "required" : ""}`} key={index} onClick={onAddClick}>
								<div className="itemImage">
									<div className="avatar">
										<div className="icon" />
									</div>
								</div>
								<div className="itemBody">
									<div className="title">
										{required
											? _("bookingWizard.players.emptyCell.required")
											: _("bookingWizard.players.emptyCell.optional")}
									</div>
								</div>
							</div>
						);
				  })
				: null}
		</div>
	);
};

export default Players;
